import WidgetList from '../../editor/components/WidgetList';
import { compose, branch, renderNothing } from 'recompose';

import { withEventWidgets } from '../hoc/widgets';

const EventOverview = compose(branch(({ eventId }) => !eventId, renderNothing))(withEventWidgets(WidgetList));

export default EventOverview;



/** WEBPACK FOOTER **
 ** ../src/dash/front/widget-picker/containers/EventOverview.js
 **/